class AdminController {
  constructor() {
    this.name = 'admin';
  }
}

export default AdminController;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin.controller.js